'use client';

import Image from '@src/components/atoms/safe-image';
import Link from 'next/link';

// Components
import Chip from '@src/components/atoms/chip';

// Helper
import toRupiah from '@src/helper/toRupiah';

// Assets
import Century21 from '@public/png/i-century-21-indonesia-gold.png';

const CardJob = ({ job, href, onClick }) => {
  const {
    title,
    location,
    workType,
    employmentType,
    salaryMin,
    salaryMax,
    postedAt,
    deadline,
    isClosingSoon,
  } = job;

  const Wrapper = href ? Link : 'div';

  return (
    <Wrapper
      href={href}
      className="flex flex-col p-[12px] bg-white border-[0.5px] border-solid border-[#E6E7E8] rounded-[4px] cursor-pointer transition-shadow hover:border-[#BEAF87] hover:shadow-[0_0_8px_0_rgba(38,38,39,0.08)]"
      onClick={onClick}
    >
      <Image
        src={Century21}
        alt="CENTURY 21 Indonesia"
        width={500}
        height={20}
        className="object-contain object-left h-[20px] mb-[8px]"
      />

      <p className="font-satoshi-bold text-[#141415] text-[17px] leading-[23.8px] tracking-[-0.17px]">
        {title}
      </p>
      <p className="font-satoshi text-[#686A68] text-[13px] leading-[18px] mb-[8px]">
        {location}
      </p>

      <div className="flex flex-wrap items-center gap-[4px] mb-[8px]">
        <Chip className="bg-[#F2F2F2] text-[#252526]">{workType}</Chip>
        <Chip className="bg-[#F2F2F2] text-[#252526]">{employmentType}</Chip>
        {isClosingSoon && (
          <Chip className="bg-[#F4DC6A] text-[#897300] !rounded-[24px]">
            Segera Berakhir
          </Chip>
        )}
      </div>

      <p className="font-satoshi text-[#252526] text-[15px] leading-[21px] mb-[24px]">
        {salaryMin && salaryMax
          ? `Rp${toRupiah(salaryMin)} - Rp${toRupiah(salaryMax)}`
          : '\u00A0'}
      </p>

      <div className="mt-auto flex items-center justify-between gap-2 font-satoshi text-[#686A68] text-[11px] leading-[14px]">
        <span>{postedAt}</span>
        <span>{deadline}</span>
      </div>
    </Wrapper>
  );
};

export default CardJob;
